import { render } from "./mail_batch.vue?vue&type=template&id=a0078774&scoped=true"
import script from "./mail_batch.vue?vue&type=script&lang=js"
export * from "./mail_batch.vue?vue&type=script&lang=js"

import "./mail_batch.vue?vue&type=style&index=0&id=a0078774&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0078774"]])

export default __exports__